import { render } from "./faq.vue?vue&type=template&id=7d45a5dc&ts=true"
import script from "./faq.vue?vue&type=script&lang=ts"
export * from "./faq.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./faq.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__